import React from 'react';
import styled from 'styled-components';

import { useTranslations } from '@lang';
import { filterNullElements } from '@common/adapters/spaDayAdapter';
import { Extras } from '@common/components/Extras';
import Alert, { AlertTypes } from '@common/components/Alert/Alert';

const SelectFollowingOptionTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 11px;
  background: ${({ theme }) => theme.customColors.header};
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  border-radius: 4px;
`;

const ItemsWrapper = styled.div`
  padding: 20px 0 20px 20px;
`;

const getSelectedOptions = (singleGroup) =>
  Object.values(Object.values(singleGroup.treatments)).flat().length;

const SelectionGroups = ({
  selectionGroups = [],
  selectedGuests,
  selectedGroups,
  meta: { error, touched, submitFailed },
}) => {
  const { t } = useTranslations();

  return selectionGroups.map((selectionGroup) => {
    const singleGroup = selectedGroups?.[`group-${selectionGroup.id}`];

    const selectedOptions = singleGroup
      ? getSelectedOptions({ treatments: filterNullElements(singleGroup.treatments) })
      : 0;

    const groupError = error?.[`group-${selectionGroup.id}`];

    const numberOfGuests = selectedGuests.length;
    const numberOfRequiredSelections = selectionGroup.required * numberOfGuests;

    return (
      <div key={selectionGroup.id}>
        <SelectFollowingOptionTitleRow>
          <p>
            {t('"treatment.selectFollowingOptions', {
              action: <b>{t('treatment.selectAmount', { amount: selectionGroup.required })}</b>,
            })}
          </p>
          {t('treatment.optionsSelected', {
            selected: selectedOptions,
            required: numberOfRequiredSelections,
          })}
        </SelectFollowingOptionTitleRow>
        {(touched || submitFailed) && groupError && (
          <Alert
            type={AlertTypes.Error}
            content={t('treatment.pleaseSelectFollowingOptions', {
              action: <b>{t('treatment.selectAmount', { amount: selectionGroup.required })}</b>,
            })}
          />
        )}
        <ItemsWrapper>
          <Extras
            fieldPrefix={`selectionGroups.group-${selectionGroup.id}.treatments`}
            extras={selectionGroup.treatments}
            selectedGuests={selectedGuests}
          />
        </ItemsWrapper>
        <ItemsWrapper>
          <Extras
            fieldPrefix={`selectionGroups.group-${selectionGroup.id}.classes`}
            extras={selectionGroup.classes}
            selectedGuests={selectedGuests}
          />
        </ItemsWrapper>
      </div>
    );
  });
};

export default SelectionGroups;
